export default __webpack_public_path__ + "6baec8fd6f215f4d3716cccb9f6b8e26.svg";